(function () {
  if (window.__amcSeatsBadge) return;
  window.__amcSeatsBadge = true;

  var START_COUNT = 198;
  var INTERVAL_MS = 40 * 60 * 1000;
  /* Campaign epoch — all visitors share the same seat count */
  var START_MS = Date.UTC(2026, 8, 18, 8, 0, 0);
  var MIN_COUNT = 1;

  function seatsLeft() {
    var ticks = Math.floor((Date.now() - START_MS) / INTERVAL_MS);
    if (ticks < 0) ticks = 0;
    return Math.max(MIN_COUNT, START_COUNT - ticks);
  }

  function labelFor(n) {
    return n === 1 ? 'seat left!' : 'seats left!';
  }

  function renderDigits(countEl, n) {
    var digits = String(n).split('');
    var html = '';
    for (var i = 0; i < digits.length; i++) {
      html += '<span class="amc-pdp-cta__seats-digit">' + digits[i] + '</span>';
    }
    countEl.innerHTML = html;
  }

  function paint(el) {
    var n = seatsLeft();
    var countEl = el.querySelector('[data-amc-seats-count]');
    var labelEl = el.querySelector('[data-amc-seats-label]');
    if (countEl) renderDigits(countEl, n);
    if (labelEl) labelEl.textContent = labelFor(n);
    el.setAttribute('aria-label', n + ' ' + labelFor(n));
  }

  function refresh() {
    document.querySelectorAll('[data-amc-seats-badge]').forEach(paint);
  }

  refresh();
  setInterval(refresh, 60 * 1000);
})();
